import {
  CLIENTS_LOAD_REQUEST,
  CLIENTS_LOAD_SUCCESS,
  CLIENTS_LOAD_FAILURE
} from '../types/clients-types';

const initialState = {
  loading: false,
  clients: []
};

function clients(state = initialState, action: any = null) {
  switch (action.type) {
    case CLIENTS_LOAD_REQUEST:
      return {
        ...state,
        loading: true
      };

    case CLIENTS_LOAD_FAILURE:
      return {
        ...state,
        loading: false
      };

    case CLIENTS_LOAD_SUCCESS:
      return {
        ...state,
        clients: action.payload,
        loading: false
      };

    default:
      return state;
  }
}

export default clients;
